var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgEnvelope = function SvgEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 3.625A.376.376 0 0 0 2.125 4v.518l4.043 3.32a1.31 1.31 0 0 0 1.666 0l4.041-3.32V4a.376.376 0 0 0-.375-.375zm-.375 2.349V10c0 .207.169.375.375.375h9a.376.376 0 0 0 .375-.375V5.974L8.547 8.707c-.9.738-2.196.738-3.094 0zM1 4c0-.827.673-1.5 1.5-1.5h9c.827 0 1.5.673 1.5 1.5v6c0 .828-.673 1.5-1.5 1.5h-9c-.827 0-1.5-.672-1.5-1.5z"
  })));
};
export default SvgEnvelope;